<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Assign Tasks to {{ horse.name }}</h3>
				</div>
			</div>
			<div class="row" v-if="init">
				<div v-for="task in taskList" :key="task.id" class="col-md-6">
					<InputCheckbox :id="task.id" :name="task.name" :form="assignedTasks" :errors="{}"/>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<button @click="save">Save Tasks</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from './../Modal.vue'
import InputCheckbox from '../Form/InputCheckbox.vue'

export default {
	components: {
		Modal,
		InputCheckbox
	},
	props: ['horse', 'tasks'],
	data() {
		return {
			assignedTasks: {},
			init: false
		}
	},
	computed : {
		...mapState({
			taskList: state => state.tasks.list
		})
	},
	methods: {
		save() {
			let savedTasks = []

			for(let taskId in this.assignedTasks) {
				if(this.assignedTasks[taskId]) {
					savedTasks.push(taskId)
				}
			}
			this.$emit('assignTasks', savedTasks)
		}
	},
	mounted() {
		this.tasks.forEach(taskId => {
			this.assignedTasks[taskId] = true
		})
		this.init = true
	}, 
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Board/AssignTasks.vue